import { PillButton } from '@/components/generals/pill-button'
import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/generals/section-heading'
import {
    AI_FEATURES,
    FeatureGrid,
    ProgressLine,
    useSeenSet
} from '@/components/landing/ai/feature-grid'

export const AiAdvisor = () => {
    const { seen, markSeen } = useSeenSet()

    return (
        <section id='ai-advisor' aria-label='The Verdane AI advisor' className='relative py-24 sm:py-32'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-x-0 top-24 h-[520px] bg-[radial-gradient(45%_60%_at_50%_0%,rgba(143,174,98,0.14),transparent_70%)]' />

            <div className='shell relative'>
                <SectionHeading
                    eyebrow='Verdane AI'
                    title='Advice that *knows your numbers*'
                    subtitle='Ask in your own words, see the months ahead and hand off the sorting, all explained plainly.'
                >
                    <ProgressLine seen={seen} total={AI_FEATURES.length} className='mt-10' />
                </SectionHeading>

                <FeatureGrid onVisible={markSeen} className='mt-14' />

                <Reveal className='mt-12 flex justify-center'>
                    <PillButton href='/ai-intelligence' variant='glass' size='md'>
                        See AI Intelligence at work
                    </PillButton>
                </Reveal>
            </div>
        </section>
    )
}
